import type { Message, Session, UserMessage } from "@mux/sdk/v2/client"

export type SessionModelHydration =
  | {
      source: "session"
      id: string
      agent?: string
      providerID: string
      modelID: string
      variant?: string
    }
  | {
      source: "message"
      message: UserMessage
    }

export function sessionModelHydration(
  sessionID: string,
  sessions: readonly Session[],
  messages: readonly Message[],
): SessionModelHydration | undefined {
  const session = sessions.find((item) => item.id === sessionID)
  if (session?.providerID && session.modelID) {
    return {
      source: "session",
      id: session.id,
      agent: session.agent,
      providerID: session.providerID,
      modelID: session.modelID,
      variant: session.variant,
    }
  }

  const message = messages.findLast((item): item is UserMessage => item.role === "user")
  if (!message) return
  return { source: "message", message }
}
